module.exports = __webpack_public_path__ + "img/pathnav.98872164.png";